export default __webpack_public_path__ + "static/media/farm.9ce41122.svg";